import React from 'react';
import styles from  './video.module.scss'; 


const Video = () =>{


    return( 
        <div className={styles.videoWrapper}>
            <div className={styles.videoResponsive}>
                <iframe 
                    width="560" 
                    height="315" 
                    src="https://www.youtube.com/embed/re1LykddvbI" 
                    title="YouTube video player" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" 
                    allowFullScreen>
                </iframe>
            </div>
        </div>
    )
}

export default Video;